import { UserRole } from '@reenstudio/app/core/enum/user-role';

export class User {
  id: string;
  name: string;

  email: string;

  level: UserRole;

  constructor(id: string, name: string, email: string, level: UserRole) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.level = level;
  }

  isSimpleUser() {
    return this.level === UserRole.SITE;
  }

  isCer() {
    return this.level === UserRole.CER;
  }

  isAdmin() {
    return this.level === UserRole.ADMIN;
  }

  isIntrapresa() {
    return this.level === UserRole.INTRAPRESA;
  }

  getLevel() {
    return this.level;
  }
}
